import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { isEqual } from 'lodash-es';
const REQUIRED_NAME_SEARCH_FIELDS = [
    'agreementName',
    'clientName',
    'services',
    'packages'
];
const OPTIONAL_NAME_SEARCH_FIELD = 'bundles';
const singleKey = (value)=>{
    const keys = Object.keys(value);
    return keys.length === 1 ? keys[0] : undefined;
};
const armNameMatch = (arm)=>{
    const field = singleKey(arm);
    if (field === 'agreementName' || field === 'clientName') return arm[field];
    if (field === 'services' || field === 'packages' || field === 'bundles') {
        var _arm_field;
        var _arm_field1;
        const quantified = (_arm_field1 = arm[field]) === null || _arm_field1 === void 0 ? void 0 : _arm_field1.any;
        return quantified != null && singleKey((_arm_field = arm[field]) !== null && _arm_field !== void 0 ? _arm_field : {}) === 'any' && singleKey(quantified) === 'name' ? quantified.name : undefined;
    }
    return undefined;
};
const isWideNameSearchGroup = (arms)=>{
    const fields = new Set(arms.flatMap((arm)=>Object.keys(arm)));
    const distinctNameFieldsOnly = fields.size === arms.length && [
        ...fields
    ].every((field)=>field === OPTIONAL_NAME_SEARCH_FIELD || REQUIRED_NAME_SEARCH_FIELDS.some((f)=>f === field));
    const coversRequiredFields = REQUIRED_NAME_SEARCH_FIELDS.every((field)=>fields.has(field));
    const matches = arms.map(armNameMatch);
    return distinctNameFieldsOnly && coversRequiredFields && matches.every((match)=>match != null && isEqual(match, matches[0]));
};
const isWideNameSearch = (filter)=>filter.or != null && isWideNameSearchGroup(filter.or);
export const hidesWideNameSearchChips = (param)=>{
    let { filter, filterEditedSinceLastSearch, orArmMatchCounts, errorCode } = param;
    if (filter == null || filterEditedSinceLastSearch || errorCode != null || !isWideNameSearch(filter)) return false;
    if (orArmMatchCounts == null || !isEqual(orArmMatchCounts.filter, filter)) return true;
    return orArmMatchCounts.counts != null && orArmMatchCounts.counts.every((count)=>count === 0);
};
export const pruneWideNameSearchArms = (filter, orArmMatchCounts)=>{
    const arms = filter.or;
    if (arms == null || arms.length !== orArmMatchCounts.length || !isWideNameSearchGroup(arms)) return undefined;
    const surviving = arms.filter((_arm, index)=>orArmMatchCounts[index] > 0);
    if (surviving.length === 0 || surviving.length === arms.length) return undefined;
    const { or: _omittedGroup } = filter, rest = _object_without_properties(filter, [
        "or"
    ]);
    if (surviving.length > 1) return _object_spread_props(_object_spread({}, rest), {
        or: surviving
    });
    const [survivor] = surviving;
    const siblingFields = new Set(Object.keys(rest));
    const collidesWithSibling = Object.keys(survivor).some((field)=>siblingFields.has(field));
    return collidesWithSibling ? undefined : _object_spread({}, rest, survivor);
};
